import { useDisclosure } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useChatStudioRedirect } from "@/hooks/useChatStudioRedirect";
import { useAppParameters } from "@/hooks/useAppParameters";

export const useHandleStoryTypeModal = () => {
  const navigate = useNavigate();
  const { goToChatStudio } = useChatStudioRedirect();
  const { defaultTags, clearDefaultTags } = useAppParameters();
  const storyTypeModalDisclosure = useDisclosure({
    defaultOpen: defaultTags.length > 0,
  });

  const toWriteNovel = () => {
    navigate(
      `/novel/new/episodes/new?from=home${
        defaultTags.length > 0 ? `&tags=${defaultTags.join(",")}` : ""
      }`,
    );
    clearDefaultTags();
  };
  const toWriteChatNovel = () => {
    storyTypeModalDisclosure.onClose();
    goToChatStudio("/stories/new");
    clearDefaultTags();
  };

  return {
    storyTypeModalDisclosure,
    toWriteNovel,
    toWriteChatNovel,
  };
};
